
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  // Safely scroll to the element with id="apply"
  const scrollToApply = () => {
    // Guard against server‑side rendering where `document` is undefined
    if (typeof document === 'undefined') return;

    const element = document.getElementById('apply');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute w-96 h-96 bg-[#d4af37]/5 rounded-full blur-3xl top-20 -left-20 animate-pulse"></div>
        <div
          className="absolute w-96 h-96 bg-[#d4af37]/5 rounded-full blur-3xl bottom-20 -right-20 animate-pulse"
          style={{ animationDelay: '1s' }}
        ></div>
      </div>

      <div className="max-w-[1400px] mx-auto px-8 py-32 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10">
        <div className="space-y-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 border border-[#d4af37] rounded-full">
            <span className="text-[#d4af37] text-xs tracking-widest uppercase">
              {t('hero.badge')}
            </span>
          </div>

          <h1 className="text-7xl lg:text-8xl font-light leading-[1.1] tracking-tight">
            {t('hero.title1')}
            <br />
            <span className="font-normal">{t('hero.title2')}</span>
            <br />
            <span className="font-semibold">{t('hero.title3')}</span>
          </h1>

          <p className="text-lg text-[#b8b8b8] leading-relaxed max-w-[520px]">
            {t('hero.subtitle')}
          </p>

          <div className="flex flex-wrap gap-5 pt-4">
            <button
              onClick={scrollToApply}
              className="px-12 py-4 bg-white text-black text-base font-medium rounded-full hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              {t('hero.cta1')}
            </button>
            <button
              onClick={scrollToApply}
              className="px-12 py-4 border border-white/30 text-white text-base rounded-full hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              {t('hero.cta2')}
            </button>
          </div>
        </div>

        <div className="relative h-[600px] lg:h-[700px]">
          <div className="absolute inset-0 flex items-center justify-center">
            <img
              src="https://public.readdy.ai/ai/img_res/65c94d42435ffbc991aae24233f8eb49.jpg"
              alt="Future of Home Robotics"
              className="w-full h-full object-contain object-center opacity-90"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
